@if (this.dataSource.data | async; as data) {
	@if (data.totalItemCount > 0 && data.items.length > 0) {
		<stages-card class="to-do-list">
			<span stagesCardTitle class="h5" translate="dashboard.todolist"></span>
			<article>
				<stages-grouped-data-view
					#dataView
					[listStyles]="'grouped-list dense'"
					[dataSource]="$any(dataSource)"
					[groupTemplate]="groupTemplate"
					[listItemTemplate]="listItemTemplate"
					[idFn]="ToDoListComponent.getId"
					[classesFn]="ToDoListComponent.getClasses"
					[disabledFn]="$any(ToDoListComponent.isGroupDisabled)"
					[groupIdFn]="$any(ToDoListComponent.getGroupId)"
					[translateGroupNames]="true"
					translateNone="empty"
				>
				</stages-grouped-data-view>
			</article>
			<ng-template #groupTemplate let-group>
				<div class="label">
					<span class="h3" [translate]="group.name"></span>
				</div>
			</ng-template>
			<ng-template #listItemTemplate let-task>
				<a class="label clickable" (click)="openTask(task)">
					<div class="text center">
						<span class="h4">{{ task.name }}</span>
						<div class="info">
							<span class="h6">{{ task.workspaceName }}</span>
							<span class="h6" [ngClass]="{ overdue: task.overdue }">
								{{ task.duration }}
							</span>
						</div>
					</div>
				</a>
				<stages-menu
					menuId="mtodo{{ task.id }}"
					iconClasses="ico ico-more-vertical"
					openTo="left"
					[items]="menuItems"
					[context]="task"
					[noCollapse]="false"
					class="action"
				/>
			</ng-template>
		</stages-card>
	}
}
